import { Avatar, makeStyles, MenuItem, mergeClasses } from "@fluentui/react-components";
import type { IGraphPickerItem } from "../../../interfaces";
import { UserAvatar } from "../../UserAvatar/UserAvatar";
import { CheckboxCheckedRegular, CheckboxUncheckedRegular } from "@fluentui/react-icons";

const buildStyle = makeStyles({
    menuItem: {
        padding: "0",
        maxWidth: "100%"
    },
    content: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        height: "32px",
    },
    checkBox: {
        paddingRight: "5px",
        height: "24px",
        width: "24px"
    },
    title: {
        textWrap: "nowrap",
        textOverflow: "ellipsis",
        flexGrow: "1",
        flexShrink: "1",
        paddingLeft: "5px"
    }
});

export interface IUserPickerSearchItemProps {
    selectedUsers: IGraphPickerItem[];
    userInfo: IGraphPickerItem;
    multiSelect: boolean;
    className?: string;
    onSelect(userInfo: IGraphPickerItem): void;
}

export function UserPickerSearchItem(props: Readonly<IUserPickerSearchItemProps>) {
    const { selectedUsers, userInfo, multiSelect, className, onSelect } = props;

    const styleClasses = buildStyle();

    const isSelected = selectedUsers.some((u) => u.id === userInfo.id);
    const itemIcon = userInfo.type === "group"
        ? <Avatar name={userInfo.displayName} size={24} />
        : <UserAvatar userId={userInfo.id} displayName={userInfo.displayName} size={24} />;

    const onClick = (ev: React.MouseEvent): void => {
        ev.preventDefault();
        ev.stopPropagation();

        onSelect?.(userInfo);
    };

    return (
        <MenuItem onClick={onClick} className={mergeClasses(styleClasses.menuItem, className)}>
            <div className={styleClasses.content}>
                {
                    multiSelect && isSelected &&
                    <CheckboxCheckedRegular className={styleClasses.checkBox}/>
                }
                {
                    multiSelect && !isSelected &&
                    <CheckboxUncheckedRegular className={styleClasses.checkBox} />
                }
                {
                    itemIcon
                }
                <div className={styleClasses.title}>
                {
                    userInfo.displayName
                }
                </div>
            </div>
        </MenuItem>
    );
}